var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"caption grey--text"},[_vm._v(_vm._s(_vm.component.label))]),_c('v-chip',{staticClass:"black--text",attrs:{"label":"","disabled":""}},[_vm._v(" "+_vm._s(_vm.selectedValue)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }